<template>
	<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="3" y="8" width="4" height="17" rx="2" :stroke="color" stroke-width="2"/>
		<rect x="11" y="8" width="4" height="17" rx="2" :stroke="color" stroke-width="2"/>
		<rect x="7" y="8" width="4" height="17" rx="2" :stroke="color" stroke-width="2"/>
		<rect x="15" y="8" width="4" height="17" rx="2" :stroke="color" stroke-width="2"/>
		<rect x="19" y="8" width="4" height="17" rx="2" :stroke="color" stroke-width="2"/>
		<path opacity="0.35" d="M9 5C9 4.33333 8 4.2 8 3.66667C8 3 9 3 9 2.33333C9 1.66667 8 1.66667 8 1" :stroke="color" stroke-width="2" stroke-linecap="round"/>
		<path d="M14 5C14 4.33333 13 4.2 13 3.66667C13 3 14 3 14 2.33333C14 1.66667 13 1.66667 13 1" :stroke="color" stroke-width="2" stroke-linecap="round"/>
		<path opacity="0.35" d="M19 5C19 4.33333 18 4.2 18 3.66667C18 3 19 3 19 2.33333C19 1.66667 18 1.66667 18 1" :stroke="color" stroke-width="2" stroke-linecap="round"/>
		<path opacity="0.35" d="M3 23H1M25 10H23" :stroke="color" stroke-width="2" stroke-linecap="round"/>
	</svg>
</template>

<script>
  	export default {
    	name: 'moduleJ',
    	props: ['color'],
    }
</script>